import i18n from '@/locale';
import m_progress from '../../../node_modules/tabulator-tables/src/js/modules/Format/defaults/formatters/progress';

export function genHeaderTooltip(){
  return (e, p_column) => {
    let ret_div = document.createElement('div');
    ret_div.style.color = '#FFF';
    ret_div.style['font-size'] = '14px';
    ret_div.innerText = p_column.getDefinition().field_desc;
    return ret_div;
  };
}

export function genTooltip(tooltip_fields){
  return (e, p_cell) => {
    let ret_div = document.createElement('div');
    ret_div.style.color = '#FFF';
    ret_div.style['font-size'] = '14px';

    tooltip_fields.forEach(em_i => {
      let cell_value = p_cell.getRow().getCell(em_i).getValue();

      let child_div = document.createElement('div');
      child_div.style.display = 'flex';
      child_div.style.justifyContent = 'space-between';
      child_div.style.width = '100%';

      let title = document.createElement('span');
      title.textContent = `${i18n.tfd(em_i)}:`;
      title.style['padding-right'] = '10px';
      child_div.appendChild(title);

      let content = document.createElement('span');
      content.textContent = g_number_2_text(cell_value);
      child_div.appendChild(content);

      ret_div.appendChild(child_div);
    });
    return ret_div;
  };
}

export class TabuHandlerBase{

  constructor(){
    this.clear();
  }

  clear(){
    this._dataset = [];
    this._option = {};
    return this;
  }

  clearData(){
    return this.clear();
  }

  mergeOption(p_val){
    // _.cloneDeep(_.merge(this._option, p_val));
    _.merge(this._option, p_val);
    return this;
  }

  setDataset(p_val){
    this._dataset = p_val;
    return this;
  }

  addColumnGroup(column_group_idx, title){
    this._option.columns ??= [];
    this._option.columns.push({column_group_idx, title, columns: [], headerHozAlign: 'center'});
    return this;
  }

  addColumnToGroup(column_group_idx, column_option, settings){

    this._option.columns ??= [];

    let found_column = this._option.columns.find(el_i => el_i.column_group_idx == column_group_idx);
    if(undefined == found_column)
      return this;

    found_column.columns ??= [];
    found_column.columns.push(this.genColumnOption(column_option, settings));
    return this;
  }

  addColumn(column_option, settings){
    this._option.columns ??= [];
    this._option.columns.push(this.genColumnOption(column_option, settings));
    return this;
  }

  addColumnAt(idx, column_option, settings){
    this._option.columns ??= [];
    this._option.columns.splice(idx, 0, this.genColumnOption(column_option, settings));
    return this;
  }

  genColumnOption(column_option){
    const column_values = g_aq.from(this._dataset).column(column_option.field);
    if(0 == column_values.length)
      return;

    if(undefined == column_option.title)
      column_option.title = i18n.tfd(column_option.field);

    let ret_option = {
      headerHozAlign: 'center',
      hozAlign: 'center',
      resizable: 'header',
    };

    if(undefined != column_option.cellClick){
      _.merge(ret_option, {
        formatter: p_cell => `<span style='color: deepskyblue; font-weight: bold; text-decoration: underline;'>${p_cell.getValue()}</span>`,
      });
    }

    if('progress' == column_option?.formatter){
      let {value_min, value_max} = g_aq.from(this._dataset)
        .rollup({
          'value_min': g_aq.op.min(column_option.field),
          'value_max': g_aq.op.max(column_option.field),
        })
        .object()

      if(value_min < 0) value_min = 0;
      _.merge(ret_option, {
        headerHozAlign: 'center',
        hozAlign: 'right',
        formatterParams: {
          min: value_min,
          max: value_max,
          legendAlign: 'right',
          legendColor: p_value => p_value >= 0 ? '#FFF' : 'tomato',
        },
      });

      column_option.formatter = function(cell, formatterParams, onRendered){
        let ratio_value = '';
        if(column_option?.field_ratio){
          ratio_value = cell.getRow().getCell(column_option.field_ratio).getValue() || 0;
          ratio_value = g_number_2_text(ratio_value, {is_percent: true, fraction_digits: 2});
          ratio_value = ` (${ratio_value})`;
        }
        // formatterParams.legend = p_value => g_number_2_text(p_value, column_option?.number_format) + ratio_value;
        formatterParams.legend = p_value => `<span style='font-weight: bold;'>${g_number_2_text(p_value, column_option?.number_format) + ratio_value}</span>`;
        return m_progress.apply(this, [cell, formatterParams, onRendered]);
        // return m_progress.apply(this, arguments);
      };
    }

    if('ranking' == column_option?.formatter){
      column_option.formatter = function(cell, formatterParams, onRendered){
        const rank_value = cell.getValue();
        const diff_value = cell.getRow().getCell(column_option.field_gr_amt).getValue() || 0;
        const [cell_class, cell_style] = (() => {
          if(diff_value == 0) return ['fa fa-minus', ''];
          if(diff_value < 0) return ['fa fa-arrow-up', 'color: limegreen;'];
          if(diff_value > 0) return ['fa fa-arrow-down', 'color: tomato;'];
        })();
        const cell_html = (diff_value == 0 ? '' : `<span style='${cell_style}'>${Math.abs(diff_value)}</span>`);
        return `${rank_value} <i class='${cell_class}' style='${cell_style}'></i>${cell_html}`;
      }
    }
    if('percent' == column_option?.formatter){
      column_option.formatter = function(cell, formatterParams, onRendered){
        const cell_value = cell.getValue() || 0;
        return `<span style='float:right; font-weight: bold; color: ${cell_value >= 0 ? 'limegreen' : 'tomato'};'>${g_number_2_text(cell_value, {is_percent: true, fraction_digits: 2})}</span>`;
      }
    }

    if(column_option?.field_desc?.length > 0)
      _.merge(ret_option, {headerTooltip: genHeaderTooltip()});

    if(column_option?.tooltip_fields?.length > 0)
      _.merge(ret_option, {tooltip: genTooltip(column_option.tooltip_fields)});

    return _.merge(ret_option, column_option);
  }

  setColumnOption(column_idx, column_option){
    if(undefined != this._option.columns)
      _.merge(this._option.columns[column_idx], column_option)
    return this;
  }

  setColumnOptionAll(column_option){
    if(undefined != this._option.columns){
      this._option.columns.forEach((el_i, idx_i) => {
        _.merge(this._option.columns[idx_i], column_option)
      });
    }
    return this;
  }
}

export class TabuHandlerSimple extends TabuHandlerBase{

  initOption(){
    return this
    .clear()
    .mergeOption({
      // autoColumns: true,
      columnHeaderVertAlign: 'bottom',
      // layout: 'fitColumns',
      layout: 'fitDataFill',
      pagination: 'local',
      paginationSize: 20,
      // movableColumns: true,
      tooltipGenerationMode: 'hover',
    });
  }
}
